<script>
  import Banner from '../utility/banner.svelte'
  import Contact from '../parts/contact.svelte'
  import Footer from '../parts/footer.svelte'

  export let title
</script>

<svelte:head>
  <title>
    {title} - Devanga Sowdeshwari Amman Association of North America (DSAANA)
  </title>
</svelte:head>

<Banner title="{title}" />

<section class="AboutUs">
  <img width="100%" src="assets/images/services/temple.jpg" alt="" />
  <div>
    <div>
      <p>
        Devanga is a sub-caste in Hinduism. They were one of the weaving castes
        in India. This page mainly deals with Kannada Devanga of Tamil Nadu who
        speaks Kannada language.
      </p>
    </div>

    <div>
      <h2>Origins</h2>
      <p>
        Devangas are of Brahmanical origin. The majority of them are weavers of
        silk and cotton clothes. There were also famous Devanga kings like Boja
        Raja of Ujjain (Uttar Pradesh, India). Many were also warriors during
        Vijayanagar times, according to warrior stones found in Hampi,
        Karnataka. Their native state was the kingdom of Ujjain where even to
        this day they form the major community. <br /><br />

        &nbsp;&nbsp;&nbsp; Their main deity is Sowdeshwari(Chamundeshwari)
        Amman. As is typical with other castes, Devangas became an endogamous
        unit of weavers, either due to caste rules or due to typical social
        conditions of India.
      </p>
    </div>

    <div>
      <h2>Myth of origin</h2>
      <p>
        Devangas trace the origin of their weaving tradition to a sage called
        Devala Maharshi. According to tradition, Devala Maharishi was the first
        person to weave the cotton cloth and to give it to Lord Shiva, who up
        until this time had been using animal skin. When Devala was taking the
        cloth to the king, demons came to attack him. Goddess Sowdeshwari
        (Chamundeshwari, A form of Durga, A warrior Goddess created by the Gods
        Brahma, Vishnu and Rudra, to fight the demon Mahishasura), perched on a
        lion, fought and vanquished the demons so that Devala Maharishi could
        give the cloth to the king. The woven clothes were taken to Lord Shiva.
        (Check Devanga Purana).
      </p>
    </div>

    <div>
      <h2>The Move to Tamil Nadu</h2>
      <p>
        This group of Devangas served the Vijaya empire in all disciplines and
        as well as were the close associates to the King in all ways. Due to
        this relationship Devangas were able to find a place in the Kings court.
        At the time of Islamic invasion, this group of people has to leave the
        empire. After the decline of Vijayanagar Kingdom, they settled in all
        parts of Tamil Nadu. The trading members of Devanga community, were able
        to lead the groups of people towards all of their trading destinations.
        Many moved towards the south towards the river banks of Cauvery in Tamil
        Nadu and settled there. <br /><br />

        This group of Kannada Devanga where ever they moved, they moved
        together. There is a large Kannada speaking community of Kannada
        Devangas in Tamil Nadu are mainly based in Kullichettipatti,
        Chinnalapatti, T.Kunnathur, Salem, Theni, Palanichettipatti (PCPatti),
        Bodinayakanur, Kambam, Tirupur, Coimbatore, Mettupalayam, Coimbatore,
        Komarapalayam, Pallipalayam, Erode, Dindugal, Aruppukottai, Sulakkarai,
        Madurai, Sankaralingapuram, Kanniseri , Chennai and Virudhunagar and
        many other places in Tamil Nadu. <br /><br />

        In Most of the places they moved, they constructed very good schools and
        colleges and even now they are well known schools of Tamil Nadu. Because
        of that now, Devanga Literacy in Tamil Nadu is high about 75% of them
        and most of them are renowned Doctors, Engineers and also in Leading
        Government Positions.
      </p>
    </div>

    <br /><br /><br /><br /><br />
  </div>
</section>

<!-- <Contact /> -->
<Footer />

<style lang="scss">
  .AboutUs {
    width: 90%;
    margin: auto;

    div {
      margin-top: 50px;
    }
  }
</style>
